// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__wideContainer___GYD0E {
    width: 100%;
    height: 100%;
    padding: 0 var(--container-padding-horizontal);
    box-sizing: border-box;
}

.styles__container___gDyW0 {
    width: 100%;
    height: 100%;
    max-width: var(--mobile-page-width);
    margin: 0 auto;
    padding: 70px 0; /* header footer heights + 20px */
}

@media screen and (min-width: 768px) {
    .styles__container___gDyW0 {
        max-width: var(--tablets-page-width);
        padding: 80px 0;
    }
}

@media screen and (min-width: 1024px) {
    .styles__container___gDyW0 {
        max-width: var(--desktop-page-width);
    }
}
`, "",{"version":3,"sources":["webpack://./../../shared/components/Main/styles.css"],"names":[],"mappings":"AAEA;IACI,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,cAAc;IACd,eAAe,EAAE,iCAAiC;AACtD;;AAEA;IACI;QACI,oCAAoC;QACpC,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,oCAAoC;IACxC;AACJ","sourcesContent":["@import \"../../styles/variables.css\";\n\n.wideContainer {\n    width: 100%;\n    height: 100%;\n    padding: 0 var(--container-padding-horizontal);\n    box-sizing: border-box;\n}\n\n.container {\n    width: 100%;\n    height: 100%;\n    max-width: var(--mobile-page-width);\n    margin: 0 auto;\n    padding: 70px 0; /* header footer heights + 20px */\n}\n\n@media screen and (min-width: 768px) {\n    .container {\n        max-width: var(--tablets-page-width);\n        padding: 80px 0;\n    }\n}\n\n@media screen and (min-width: 1024px) {\n    .container {\n        max-width: var(--desktop-page-width);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wideContainer": `styles__wideContainer___GYD0E`,
	"container": `styles__container___gDyW0`
};
export default ___CSS_LOADER_EXPORT___;
